import {
    getToken,
    customersOptions,
    regionsOptions,
    statesOptions,
    locationsOptions,
    technicalManagerOptions,
    anticoccidialOptions,
    agpOptions,
    probioticOptions,
    districtOptions
} from "helper/common";
import {
    CLEAR_FARM_RECORD_DETAILS,
    CLEAR_FARM_RECORD_LIST,
    SET_FARM_RECORD_DETAILS,
    SET_FARM_RECORD_LIST,
    FARM_RECORD_DETAILS_ERROR,
    FARM_RECORD_DETAILS_ERROR_CLEAR,
    FARM_RECORD_DETAILS_PENDING,
    FARM_RECORD_LIST_ERROR,
    FARM_RECORD_LIST_ERROR_CLEAR,
    FARM_RECORD_LIST_PENDING,
    SET_LAB_RECORDS,
    CLEAR_LAB_RECORDS,
    LAB_RECORDS_PENDING,
    LAB_RECORDS_ERROR,
    LAB_RECORDS_ERROR_CLEAR,
    FARM_RECORDS_EXPORT_PENDING,
    FARM_RECORDS_EXPORT_ERROR,
    FARM_RECORDS_EXPORT_ERROR_CLEAR,
    OVERALL_SUMMARY_PENDING,
    SET_OVERALL_SUMMARY,
    CLEAR_OVERALL_SUMMARY,
    OVERALL_SUMMARY_ERROR,
    OVERALL_SUMMARY_ERROR_CLEAR,
    SET_FARM_RECORDS_FILTER_DATA,
    FARM_RECORDS_FILTER_DIALOG_CLOSE,
    FARM_RECORDS_FILTER_DIALOG_OPEN,
} from "./constants";
import agent from "store/service/agent";
// import { encodeObjectValues } from "helper/encodeData";
import { openSnackbar } from "store/slices/snackbar";

//-----------------------------|| LIST ||-----------------------------------------------------------------
export const setFarmRecordList = (farmRecordList) => ({
    type: SET_FARM_RECORD_LIST,
    payload: { farmRecordList }
});

export const clearFarmRecordList = () => ({
    type: CLEAR_FARM_RECORD_LIST,
});

export const farmRecordListPending = () => ({
    type: FARM_RECORD_LIST_PENDING
});

export const farmRecordListError = (errorMessage) => ({
    type: FARM_RECORD_LIST_ERROR,
    payload: { errorMessage }
});

export const farmRecordListErrorClear = () => ({
    type: FARM_RECORD_LIST_ERROR_CLEAR
});

export const getFarmRecordList = (page, pageSize, sortOrder, sortDirection, filter) => (dispatch) => {
    // const encodeFilters = encodeObjectValues({ ...filter });
    dispatch(farmRecordListPending());
    return getToken(dispatch).then((accessToken) => {
        return agent.farmRecords.getFarmRecordList(accessToken, page, pageSize, sortOrder, sortDirection, filter)
            .then((farmRecordList) => {
                dispatch(setFarmRecordList(farmRecordList));
                dispatch(farmRecordListErrorClear());
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body.error.message;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(farmRecordListError(message));
                }
                else {
                    dispatch(farmRecordListError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}

//-----------------------------|| FILTER ||-------------------------------------------------------------
export const openFarmRecordsFilterDialog = () => ({
    type: FARM_RECORDS_FILTER_DIALOG_OPEN
});

export const closeFarmRecordsFilterDialog = () => ({
    type: FARM_RECORDS_FILTER_DIALOG_CLOSE
});

export const setFarmRecordsFilteredData = (filter) => ({
    type: SET_FARM_RECORDS_FILTER_DATA,
    payload: { filter },
});

export const getTechnicalManagerOption = (search, page, pageSize) => (dispatch) => {
    return getToken(dispatch).then((accessToken) => {
        return agent.farmRecords.getTechnicalManagerOption(accessToken, search, page, pageSize)
            .then((userList) => {
                const { value } = userList || [];
                const options = technicalManagerOptions(value);
                return Promise.resolve(options);
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body.error.message;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(openSnackbar({
                        open: true,
                        message: 'Something went wrong. Try again.',
                        variant: 'alert',
                        close: false
                    }))
                    return Promise.reject(message);
                }
                else {
                    const message = ":( Network Error";
                    dispatch(openSnackbar({
                        open: true,
                        message: 'Something went wrong. Try again.',
                        variant: 'alert',
                        close: false
                    }))
                    return Promise.reject(message);
                }
            })
    })
}

export const getCustomerOption = (search, page, pageSize) => (dispatch) => {
    return getToken(dispatch).then((accessToken) => {
        return agent.farmRecords.getCustomerOption(accessToken, search, page, pageSize)
            .then((userList) => {
                const { value } = userList || [];
                const options = customersOptions(value);
                return Promise.resolve(options);
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body.error.message;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(openSnackbar({
                        open: true,
                        message: 'Something went wrong. Try again.',
                        variant: 'alert',
                        close: false
                    }))
                    return Promise.reject(message);
                }
                else {
                    const message = ":( Network Error";
                    dispatch(openSnackbar({
                        open: true,
                        message: 'Something went wrong. Try again.',
                        variant: 'alert',
                        close: false
                    }))
                    return Promise.reject(message);
                }
            })
    })
}
export const getLocationOption = (search, recordstatus) => (dispatch) => {
    return getToken(dispatch).then((accessToken) => {
        return agent.farmRecords.getLocationOption(accessToken, search)
            .then((locationsList) => {
                const options = locationsOptions(locationsList);
                if (recordstatus) {
                    const filteredOptions = options?.filter((option) => option.type.toLowerCase() === recordstatus.toLowerCase());
                    return Promise.resolve(filteredOptions);
                }
                else {
                    //-----------REMOVE DUPLICATE OPTION-------------------------
                    const seen = new Set();
                    const uniqueOptions = options.filter(option => {
                        if (seen.has(option.label)) return false;
                        seen.add(option.label);
                        return true;
                    });

                    return Promise.resolve(uniqueOptions);
                }

            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body.error.message;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(openSnackbar({
                        open: true,
                        message: 'Something went wrong. Try again.',
                        variant: 'alert',
                        close: false
                    }))
                    return Promise.reject(message);
                }
                else {
                    const message = ":( Network Error";
                    dispatch(openSnackbar({
                        open: true,
                        message: 'Something went wrong. Try again.',
                        variant: 'alert',
                        close: false
                    }))
                    return Promise.reject(message);
                }
            })
    })
}
export const getRegionOption = (search, type, page, pageSize) => (dispatch) => {
    return getToken(dispatch).then((accessToken) => {
        return agent.farmRecords.getRegionOption(accessToken, search, type, page, pageSize)
            .then((regionList) => {
                const { value } = regionList || [];
                const options = regionsOptions(value);
                return Promise.resolve(options);
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body.error.message;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(openSnackbar({
                        open: true,
                        message: 'Something went wrong. Try again.',
                        variant: 'alert',
                        close: false
                    }))
                    return Promise.reject(message);
                }
                else {
                    const message = ":( Network Error";
                    dispatch(openSnackbar({
                        open: true,
                        message: 'Something went wrong. Try again.',
                        variant: 'alert',
                        close: false
                    }))
                    return Promise.reject(message);
                }
            })
    })
}
export const getStateOption = (search, region, page, pageSize) => (dispatch) => {
    return getToken(dispatch).then((accessToken) => {
        return agent.farmRecords.getStateOption(accessToken, search, region, page, pageSize)
            .then((stateList) => {
                const { value } = stateList || [];
                const options = statesOptions(value);
                return Promise.resolve(options);
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body.error.message;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(openSnackbar({
                        open: true,
                        message: 'Something went wrong. Try again.',
                        variant: 'alert',
                        close: false
                    }))
                    return Promise.reject(message);
                }
                else {
                    const message = ":( Network Error";
                    dispatch(openSnackbar({
                        open: true,
                        message: 'Something went wrong. Try again.',
                        variant: 'alert',
                        close: false
                    }))
                    return Promise.reject(message);
                }
            })
    })
}

export const getDistrictOption = (search, state, region, page, pageSize) => (dispatch) => {
    return getToken(dispatch).then((accessToken) => {
        return agent.farmRecords.getDistrictOption(accessToken, search, state, region, page, pageSize)
            .then((stateList) => {
                const { value } = stateList || [];
                const options = districtOptions(value);
                return Promise.resolve(options);
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body.error.message;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(openSnackbar({
                        open: true,
                        message: 'Something went wrong. Try again.',
                        variant: 'alert',
                        close: false
                    }))
                    return Promise.reject(message);
                }
                else {
                    const message = ":( Network Error";
                    dispatch(openSnackbar({
                        open: true,
                        message: 'Something went wrong. Try again.',
                        variant: 'alert',
                        close: false
                    }))
                    return Promise.reject(message);
                }
            })
    })
}
export const getAnticocidalOption = (search, page, pageSize) => (dispatch) => {
    return getToken(dispatch).then((accessToken) => {
        return agent.farmRecords.getAnticocidalOption(accessToken, search, page, pageSize)
            .then((stateList) => {
                const { value } = stateList || [];
                const options = anticoccidialOptions(value);
                return Promise.resolve(options);
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body.error.message;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(openSnackbar({
                        open: true,
                        message: 'Something went wrong. Try again.',
                        variant: 'alert',
                        close: false
                    }))
                    return Promise.reject(message);
                }
                else {
                    const message = ":( Network Error";
                    dispatch(openSnackbar({
                        open: true,
                        message: 'Something went wrong. Try again.',
                        variant: 'alert',
                        close: false
                    }))
                    return Promise.reject(message);
                }
            })
    })
}
export const getAGPOption = (search, page, pageSize) => (dispatch) => {
    return getToken(dispatch).then((accessToken) => {
        return agent.farmRecords.getAGPOption(accessToken, search, page, pageSize)
            .then((stateList) => {
                const { value } = stateList || [];
                const options = agpOptions(value);
                return Promise.resolve(options);
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body.error.message;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(openSnackbar({
                        open: true,
                        message: 'Something went wrong. Try again.',
                        variant: 'alert',
                        close: false
                    }))
                    return Promise.reject(message);
                }
                else {
                    const message = ":( Network Error";
                    dispatch(openSnackbar({
                        open: true,
                        message: 'Something went wrong. Try again.',
                        variant: 'alert',
                        close: false
                    }))
                    return Promise.reject(message);
                }
            })
    })
}

export const getProbioticOption = (search, page, pageSize) => (dispatch) => {
    return getToken(dispatch).then((accessToken) => {
        return agent.farmRecords.getProbioticOption(accessToken, search, page, pageSize)
            .then((stateList) => {
                const { value } = stateList || [];
                const options = probioticOptions(value);
                return Promise.resolve(options);
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body.error.message;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(openSnackbar({
                        open: true,
                        message: 'Something went wrong. Try again.',
                        variant: 'alert',
                        close: false
                    }))
                    return Promise.reject(message);
                }
                else {
                    const message = ":( Network Error";
                    dispatch(openSnackbar({
                        open: true,
                        message: 'Something went wrong. Try again.',
                        variant: 'alert',
                        close: false
                    }))
                    return Promise.reject(message);
                }
            })
    })
}

//-----------------------------|| OVERALL SUMMARY ||----------------------------------------------------
export const setOverallSummary = (overallSummary) => ({
    type: SET_OVERALL_SUMMARY,
    payload: { overallSummary }
});

export const clearOverallSummary = () => ({
    type: CLEAR_OVERALL_SUMMARY,
});

export const overallSummaryPending = () => ({
    type: OVERALL_SUMMARY_PENDING
});

export const overallSummaryError = (errorMessage) => ({
    type: OVERALL_SUMMARY_ERROR,
    payload: { errorMessage }
});

export const overallSummaryErrorClear = () => ({
    type: OVERALL_SUMMARY_ERROR_CLEAR
});


export const getOverallSummary = (page, pageSize, sortOrder, sortDirection, filter) => (dispatch) => {
    // const encodeFilters = encodeObjectValues({ ...filter });
    dispatch(overallSummaryPending());
    return getToken(dispatch).then((accessToken) => {
        return agent.farmRecords.getOverallSummaryDetails(accessToken, page, pageSize, sortOrder, sortDirection, filter)
            .then((overallSummary) => {
                dispatch(setOverallSummary(overallSummary));
                dispatch(overallSummaryErrorClear());
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body.error.message;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(overallSummaryError(message));
                }
                else {
                    dispatch(overallSummaryError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}

//-----------------------------|| EXPORT ||---------------------------------------------------------------
export const farmRecordsExportPending = () => ({
    type: FARM_RECORDS_EXPORT_PENDING
});

export const farmRecordsExportError = (errorMessage) => ({
    type: FARM_RECORDS_EXPORT_ERROR,
    payload: { errorMessage }
});

export const farmRecordsExportErrorClear = () => ({
    type: FARM_RECORDS_EXPORT_ERROR_CLEAR
});

export const getFarmRecordsExport = (page, pageSize, sortOrder, sortDirection, filter) => (dispatch) => {
    // const encodeFilters = encodeObjectValues({ ...filter });
    dispatch(farmRecordsExportPending());
    return getToken(dispatch).then((accessToken) => {
        return agent.farmRecords.getFarmRecordList(accessToken, page, pageSize, sortOrder, sortDirection, filter)
            .then((farmRecordList) => {
                dispatch(farmRecordsExportErrorClear());
                return Promise.resolve(farmRecordList);
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body.error.message;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(farmRecordsExportError(message))
                }
                else {
                    dispatch(farmRecordsExportError(":( Network Error"))
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}

//-----------------------------|| DETAILS ||---------------------------------------------------------------
export const setFarmRecordDetails = (farmRecordDetails) => ({
    type: SET_FARM_RECORD_DETAILS,
    payload: { farmRecordDetails }
});

export const clearFarmRecordDetails = () => ({
    type: CLEAR_FARM_RECORD_DETAILS,
});

export const farmRecordDetailsPending = () => ({
    type: FARM_RECORD_DETAILS_PENDING
});

export const farmRecordDetailsError = (errorMessage) => ({
    type: FARM_RECORD_DETAILS_ERROR,
    payload: { errorMessage }
});

export const farmRecordDetailsErrorClear = () => ({
    type: FARM_RECORD_DETAILS_ERROR_CLEAR
});

export const getFarmRecordDetails = (id) => (dispatch) => {
    dispatch(farmRecordDetailsPending());
    return getToken(dispatch).then((accessToken) => {
        return agent.farmRecords.getFarmRecordDetails(accessToken, id)
            .then((farmRecordDetails) => {
                dispatch(setFarmRecordDetails(farmRecordDetails));
                dispatch(farmRecordDetailsErrorClear());
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(farmRecordDetailsError(message));
                }
                else {
                    dispatch(farmRecordDetailsError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}

//-----------------------------||LAB RECORDS LIST ||---------------------------------------------------------------
export const setLabRecords = (labRecords) => ({
    type: SET_LAB_RECORDS,
    payload: { labRecords }
});

export const clearLabRecords = () => ({
    type: CLEAR_LAB_RECORDS,
});

export const labRecordsPending = () => ({
    type: LAB_RECORDS_PENDING
});

export const labRecordsError = (errorMessage) => ({
    type: LAB_RECORDS_ERROR,
    payload: { errorMessage }
});

export const labRecordsErrorClear = () => ({
    type: LAB_RECORDS_ERROR_CLEAR
});

export const getLabRecords = (filter) => (dispatch) => {
    // const encodeFilters = encodeObjectValues({ ...filter });
    dispatch(labRecordsPending());
    return getToken(dispatch).then((accessToken) => {
        return agent.farmRecords.getLabRecords(accessToken, filter)
            .then((labRecordList) => {
                dispatch(setLabRecords(labRecordList));
                dispatch(labRecordsErrorClear());
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body.error.message;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(labRecordsError(message));
                }
                else {
                    dispatch(labRecordsError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}